import script from "./PosManager.vue?vue&type=script&lang=ts&setup=true"
export * from "./PosManager.vue?vue&type=script&lang=ts&setup=true"

import "./PosManager.vue?vue&type=style&index=0&id=0e2ddfdf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e2ddfdf"]])

export default __exports__